export const environment = {
  production: false,
  apiUrl: 'https://stagingapi.weappmanager.com/api/v1/',
  AmpV1BaseUrl: 'https://stagingapi.weappmanager.com',
  uploadsBaseUrl: 'https://staginguploads.weappmanager.com/',
  clientId: 'gpr-frontend-implicit',
  clientRoot: 'https://staging.weappmanager.com/',
  identityProviderUrl: 'https://staging.gprlogin.nl/',
};
